// src/components/SearchBar.js
import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { AsyncTypeahead, Highlighter } from 'react-bootstrap-typeahead';
import { Search } from 'lucide-react';
import { useBookContext } from '../contexts/BookContext';
import { searchBooks } from '@/api/bookApi';


// import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import './SearchBar.css'


const SearchBar = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [autocompleteData, setAutocompleteData] = useState([])
  const { dispatch } = useBookContext();
  const navigate = useNavigate();


  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const handleSearch = async (query) => {
    setIsLoading(true);
    try {
      const data = await searchBooks(query);

      setAutocompleteData(data);
      setIsLoading(false);

    } catch (error) {
      setIsLoading(false);
      console.error('Search error:', error);
      return [];
    }
  };
  const debouncedSearch = useCallback(
    debounce(handleSearch, 300),
    [handleSearch]
  );
  const handleSelect = (selected) => {
    if (selected && selected.length > 0) {
      const selectedBook = selected[0];
      dispatch({ type: 'SET_SELECTED_BOOK', payload: selectedBook });
      // TODO: slugify id
      // console.log(`/book/${selectedBook.bookID}`, { state: { title: selectedBook.title, author: selectedBook.author } })
      console.log( selected[0])
      navigate(`/book/${selectedBook.bookID}`, { state: { title: selectedBook.title, author: selectedBook.author } });

    }
  };

  const filterBy = () => true;

  return (
    <div className="relative items-center w-full">
        <button
        type="button"
        className="absolute inset-y-0 left-0 z-10 flex items-center pl-3 text-muted-foreground hover:text-primary"
      >
        {isLoading ? (
          <div className="my-rbt-aux">
            <span className="mini-spinner"></span>
          </div>
        ) : <Search size={16} style={{ color: '#78716c' }} />}

      </button>
      <AsyncTypeahead
        id="async-example"
        filterBy={filterBy}
        isLoading={isLoading}
        labelKey="title"
        minLength={5}
        onSearch={debouncedSearch}
        onChange={handleSelect}
        options={autocompleteData}
        placeholder="Search for a book"
        emptyLabel="No books found"

        renderInput={({ inputRef, referenceElementRef, ...inputProps }) => (
          <input
            {...inputProps}
            className="flex w-full h-10 px-3 py-2 pl-10 text-sm rounded-md rounded-lg bg-[#fafaf9]   file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[#78716c] focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
            style={{ fontFamily: 'Inter' }}
            ref={(input) => {
              // Be sure to correctly handle these refs. In many cases, both can simply receive
              // the underlying input node, but `referenceElementRef can receive a wrapper node if
              // your custom input is more complex (See TypeaheadInputMulti for an example).
              inputRef(input);
              referenceElementRef(input);
            }}
          />
        )}

        renderMenuItemChildren={(option, props) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              alt={option.title}
              src={option.cover}
              className='mini-preview'
              style={{
                height: '60px',
                width: '40px',
                marginRight: '10px',

                boxShadow: '0 2px 2px -1px #a3a3a3',
                borderRadius: '3px',
                background: '#ececec'
              }}
            />
            <div>
              <div style={{ fontFamily: 'Inter', fontWeight: 500, marginBottom: '-2px' }}>{option.title}</div>
              <div style={{ color: '#919191', fontFamily: 'Inter', fontSize: '14px' }}>{option.author}</div>
            </div>
          </div>
        )}
      >





      </AsyncTypeahead>

    </div>
  );
};

export default SearchBar;
